var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2002 2.5C2.2002 2.22386 2.42405 2 2.7002 2H5.2002C5.47634 2 5.7002 2.22386 5.7002 2.5V13.5C5.7002 13.7761 5.47634 14 5.2002 14H2.7002C2.42405 14 2.2002 13.7761 2.2002 13.5V2.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2002 2.5C10.2002 2.22386 10.4241 2 10.7002 2H13.2002C13.4763 2 13.7002 2.22386 13.7002 2.5V13.5C13.7002 13.7761 13.4763 14 13.2002 14H10.7002C10.4241 14 10.2002 13.7761 10.2002 13.5V2.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.86bb93179f5615114269e2a54672eb86.svg";
export { ForwardRef as ReactComponent };